import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { colors } from '../colors';

const CustomModal = ({ 
  open, 
  title, 
  message, 
  onClose, 
  onConfirm, 
  showConfirmButton = false 
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: 300, sm: 400, md: 500 }, // Responsive width
          bgcolor: '#ffffff',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
          p: 4,
          borderRadius: '12px',
        }}
      >
        {/* Modal Title */}
        <Typography
          id="modal-title"
          variant="h6"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: 'bold',
            color: colors.primaryApplicationText,
            textAlign: 'center',
            mb: 2,
          }}
        >
          {title}
        </Typography>

        {/* Modal Message */}
        <Typography
          id="modal-description"
          sx={{
            color: '#555',
            textAlign: 'center',
            mb: 3,
            lineHeight: 1.5,
            fontSize: '1rem',
          }}
        >
          {message}
        </Typography>

        {/* Buttons */}
        {showConfirmButton ? (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
            <Button
              onClick={onConfirm}
              variant="contained"
              sx={{
                backgroundColor: colors.primaryBannerBlue,
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: colors.primaryApplicationText,
                },
              }}
            >
              Confirm
            </Button>
            <Button
              onClick={onClose}
              variant="outlined"
              sx={{
                color: colors.primaryBannerBlue,
                borderColor: colors.primaryBannerBlue,
                '&:hover': {
                  backgroundColor: '#F0F4F8',
                  borderColor: colors.primaryApplicationText,
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        ) : (
          <Button
            onClick={onClose}
            variant="contained"
            fullWidth
            sx={{
              mt: 3,
              backgroundColor: colors.primaryBannerBlue,
              color: '#ffffff',
              '&:hover': {
                backgroundColor: colors.primaryApplicationText,
              },
            }}
          >
            Close
          </Button>
        )}
      </Box>
    </Modal>
  );
};

export default CustomModal;
